"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sync = exports.scanAccounts = void 0;
const invariant_1 = __importDefault(require("invariant"));
const derivation_1 = require("@ledgerhq/coin-framework/derivation");
const bignumber_js_1 = require("bignumber.js");
const jsHelpers_1 = require("../../bridge/jsHelpers");
const account_1 = require("../../account");
const mirror_1 = require("./api/mirror");
const network_1 = require("./api/network");
const getAccountShape = (info) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { currency, derivationMode, address, initialAccount } = info;
    (0, invariant_1.default)(address, "an hedera address is expected");
    const liveAccountId = (0, account_1.encodeAccountId)({
        type: "js",
        version: "2",
        currencyId: currency.id,
        xpubOrAddress: address,
        derivationMode,
    });
    // get current account balance
    const accountBalance = yield (0, network_1.getAccountBalance)(address);
    // grab latest operation's consensus timestamp for incremental sync
    const oldOperations = (_a = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) !== null && _a !== void 0 ? _a : [];
    const latestOperationTimestamp = oldOperations[0]
        ? Math.floor(oldOperations[0].date.getTime() / 1000)
        : 0;
    // merge new operations w/ previously synced ones
    const newOperations = yield (0, mirror_1.getOperationsForAccount)(liveAccountId, address, new bignumber_js_1.BigNumber(latestOperationTimestamp).toString());
    const operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
    return {
        id: liveAccountId,
        freshAddress: address,
        balance: accountBalance.balance,
        spendableBalance: accountBalance.balance,
        operations,
        // NOTE: there are no "blocks" in hedera
        // Set a value just so that operations are considered confirmed according to isConfirmedOperation
        blockHeight: 10,
    };
});
const buildIterateResult = ({ result: rootResult }) => __awaiter(void 0, void 0, void 0, function* () {
    const accounts = yield (0, mirror_1.getAccountsForPublicKey)(rootResult.publicKey);
    const addresses = accounts.map(a => a.accountId.toString());
    return ({ currency, derivationMode, index }) => __awaiter(void 0, void 0, void 0, function* () {
        const derivationScheme = (0, derivation_1.getDerivationScheme)({
            derivationMode,
            currency,
        });
        const freshAddressPath = (0, derivation_1.runDerivationScheme)(derivationScheme, currency, {
            account: index,
        });
        return addresses[index]
            ? {
                address: addresses[index],
                publicKey: addresses[index],
                path: freshAddressPath,
            }
            : null;
    });
});
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({
    getAccountShape,
    buildIterateResult,
});
exports.sync = (0, jsHelpers_1.makeSync)({ getAccountShape });
//# sourceMappingURL=js-synchronisation.js.map